import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://www.ohsm.in";
    }, 3000); // 3 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {/* <p>This is not the main website.</p> */}
        <p>Redirecting to ohsm.in</p>
      </header>
    </div>
  );
}

export default App;
